import { Breadcrumb } from '@e3dc-react/shell/Elements/Header/Breadcrumbs'
import React from 'react'
import { useParams } from 'react-router-dom'
import { useFetchInstallation } from '../../installation/hooks/use-fetch-installation'
import { InstallationForm } from '../components/InstallationForm'
import InstallationFormLoadingSkeleton from '../components/InstallationFormLoadingSkeleton'

/**
 * Advanced settings page for a specific installation and storage.
 */
const AdvancedSettingsPage: React.FC<{ parentBreadcrumb: Breadcrumb }> = ({ parentBreadcrumb }) => {
  const { installationId } = useParams<{ installationId: string; storageId: string }>()
  const installationIdNumber = installationId ? Number.parseInt(installationId) : undefined
  const { installation, isLoading } = useFetchInstallation(installationIdNumber)

  if (isLoading || !installation) return <InstallationFormLoadingSkeleton />

  return <InstallationForm parentBreadcrumb={parentBreadcrumb} defaultValues={installation} />
}

export default AdvancedSettingsPage
